import { toast } from 'react-toastify';
import { activitiesApi } from 'entities/activities';

type deleteMechanicRequestType = {
  id: string;
  body: {
    objective_id: number;
  };
};

const deleteMechanicApi = activitiesApi.injectEndpoints({
  endpoints: (builder) => ({
    deleteMechanic: builder.mutation<any, deleteMechanicRequestType>({
      query: ({ id, body }) => ({
        url: `/promo-b2b/admin/promo-b2b/admin/activities/${id}/remove_objective/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно удалили механику', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return ['ActivitiesId'];
      },
    }),
  }),
});

export const { useDeleteMechanicMutation } = deleteMechanicApi;
